// ============================================================================
// utvonal.js — megosztható hivatkozás a szobára / témára / hozzászólásra (2026-10-18, a fejlesztési javaslatok egyike).
//
// A cím #-jele után csak AZONOSÍTÓK állnak (#/r/<szoba>[/t/<téma>[/m/<hozzászólás>]]): szöveg, név, jelszó soha. A hivatkozás
// nem ad hozzáférést: a megnyitás ugyanúgy a szoba tagságához kötött, mint bármely más nyitás; aki nem tagja a szobának,
// a megszokott kezdőképernyőt kapja (a szoba létezéséről sem tudhat meg semmit).
// ============================================================================

const AZONOSITO = /^[A-Za-z0-9_-]{1,128}$/;

/**
 * A cím hash-éből: { roomId, topicId, messageId } (hiányzó = null); null, ha nem szabályos hivatkozás.
 * @param {string} hash pl. "#/r/abc/t/def/m/ghi"
 */
export function utvonalBol(hash) {
  if (typeof hash !== "string") return null;
  const r = hash.replace(/^#/, "").split("/");
  // ["", "r", szoba, ("t", téma, ("m", hozzászólás))]
  if (r[0] !== "" || r[1] !== "r" || !AZONOSITO.test(r[2] || "")) return null;
  const ki = { roomId: r[2], topicId: null, messageId: null };
  if (r.length === 3) return ki;
  // /m/<hozzászólás> közvetlenül a szobán (csevegő-szoba), vagy /t/<téma>[/m/<hozzászólás>] (fórum-téma)
  if (r[3] === "m") {
    if (!AZONOSITO.test(r[4] || "") || r.length > 5) return null;
    ki.messageId = r[4];
    return ki;
  }
  if (r[3] !== "t" || !AZONOSITO.test(r[4] || "")) return null;
  ki.topicId = r[4];
  if (r.length === 5) return ki;
  if (r[5] !== "m" || !AZONOSITO.test(r[6] || "") || r.length > 7) return null;
  ki.messageId = r[6];
  return ki;
}

/** A hash a megadott helyhez ("" ha nincs szoba / hibás azonosító). */
export function utvonalKeszit({ roomId, topicId = null, messageId = null } = {}) {
  if (!AZONOSITO.test(roomId || "")) return "";
  let s = `#/r/${roomId}`;
  const uzenetOk = messageId && AZONOSITO.test(messageId);
  if (topicId) {
    if (!AZONOSITO.test(topicId)) return s;
    s += `/t/${topicId}`;
  }
  if (uzenetOk) s += `/m/${messageId}`;
  return s;
}

/** A teljes, megosztható hivatkozás (a mostani oldal címe + a hash; a régi hash és a lekérdezés nélkül). */
export function hivatkozasKeszit(loc, hely) {
  const hash = utvonalKeszit(hely);
  if (!hash || !loc) return "";
  return `${loc.origin}${loc.pathname}${hash}`;
}
